"use client";
import React from "react";
import Tax1 from "../Images/accounting_services.png";

function TaxServices() {
  return (
    <section className="tax-modern">
      {/* GLOWING BACKGROUND DECORATIONS */}
      <div className="bg-circle one"></div>
      <div className="bg-circle two"></div>

      <div className="container">

        {/* HEADING */}
        <h2 className="main-heading">
          <span>Our Tax Services</span>
        </h2>

        <div className="row align-items-center gy-4 gy-lg-0">
          {/* LEFT SIDE */}
          <div className="col-lg-4">
            <div className="service-card">
              <h4>Individual Tax Services</h4>
              <p>
                From tax planning to filing, we assist individuals in optimizing their tax positions, ensuring compliance with the latest tax laws.
              </p>
            </div>

            <div className="service-card mt-4">
              <h4>Tax Consulting</h4>
              <p>
                Leverage our expertise for strategic tax advice, specialized consulting, and navigating complex tax issues with confidence.
              </p>
            </div>
          </div>

          {/* CENTER HERO CARD */}
          <div className="col-lg-4 text-center">
            <div className="center-card">
              <div className="center-img-wrapper">
                <img src={Tax1} alt="" className="center-img" />
              </div>
              <h3>Accounting Services</h3>
              <p>
                Our suite of services is designed to cater to businesses of all sizes and industries. Whether you're a startup, a small business, or a large corporation, we offer a range of Accounting services tailored to meet your specific needs. From bookkeeping and payroll processing to tax planning and financial analysis, we are your one-stop solution for all.
              </p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-4">
            <div className="service-card">
              <h4>Business Tax Services</h4>
              <p>
                Our comprehensive business tax solutions cover everything from strategic tax planning to compliance, helping businesses minimize tax liabilities and enhance profitability.
              </p>
            </div>

            <div className="service-card mt-4">
              <h4>Tax Representation</h4>
              <p>
                Cases where representation is required before various authorities including but not limited to Income Tax Department and GST Trademark, RERA, FSSAI, DGFT our experienced team stands by your side, providing steadfast representation to protect your interests.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .tax-modern {
          padding: 100px 0;
          background: #f8fbff;
          position: relative;
          overflow: hidden;
        }

        /* BACKGROUND CIRCLES */
        .bg-circle {
          position: absolute;
          border-radius: 50%;
          filter: blur(140px);
          opacity: 0.15;
          pointer-events: none;
          z-index: 1;
        }

        .bg-circle.one {
          width: 450px;
          height: 450px;
          background: rgba(137, 199, 100, 0.2); /* Brand Green #89c764 */
          top: -100px;
          left: -150px;
        }

        .bg-circle.two {
          width: 500px;
          height: 500px;
          background: rgba(17, 88, 134, 0.15); /* Brand Blue #115886 */
          bottom: -150px;
          right: -100px;
        }

        .container {
          position: relative;
          z-index: 2;
        }

        /* HEADING */
        .main-heading {
          font-size: 48px;
          font-weight: 850;
          color: #0f172a;
          text-align: center;
          margin-bottom: 70px;
          position: relative;
        }

        .main-heading span {
          background: linear-gradient(135deg, #115886 30%, #89c764 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        /* Decorative line under heading */
        .main-heading::after {
          content: "";
          display: block;
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #115886, #89c764);
          margin: 15px auto 0;
          border-radius: 2px;
        }

        /* SIDE CARDS */
        .service-card {
          background: #ffffff;
          padding: 35px 30px;
          border-radius: 24px;
          box-shadow: 0 10px 30px rgba(17, 88, 134, 0.03);
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          border: 1px solid rgba(17, 88, 134, 0.08);
          position: relative;
          overflow: hidden;
        }

        .service-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(180deg, #115886, #89c764);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 45px rgba(17, 88, 134, 0.1);
          border-color: rgba(137, 199, 100, 0.4);
        }

        .service-card:hover::before {
          opacity: 1;
        }

        .service-card h4 {
          color: #115886;
          font-weight: 750;
          margin-bottom: 15px;
          font-size: 21px;
          transition: color 0.3s ease;
        }

        .service-card:hover h4 {
          color: #89c764;
        }

        .service-card p {
          color: #64748b;
          margin-bottom: 0;
          font-size: 15.5px;
          line-height: 1.8;
        }

        /* CENTER HERO CARD */
        .center-card {
          background: linear-gradient(145deg, #0d3753 0%, #061c2b 100%);
          padding: 55px 35px;
          border-radius: 32px;
          color: white;
          box-shadow: 0 20px 50px rgba(17, 88, 134, 0.25);
          transform: scale(1.05);
          transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
          border: 1px solid rgba(255, 255, 255, 0.08);
          position: relative;
          overflow: hidden;
        }

        .center-card::after {
          content: "";
          position: absolute;
          width: 150px;
          height: 150px;
          background: rgba(137, 199, 100, 0.05);
          border-radius: 50%;
          top: -50px;
          right: -50px;
          filter: blur(30px);
          pointer-events: none;
        }

        .center-card:hover {
          transform: scale(1.08) translateY(-5px);
          box-shadow: 0 30px 60px rgba(137, 199, 100, 0.3);
          border-color: rgba(137, 199, 100, 0.5);
        }

        .center-img-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.04);
          border-radius: 50%;
          width: 110px;
          height: 110px;
          margin-bottom: 25px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.4s ease;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        .center-card:hover .center-img-wrapper {
          transform: scale(1.08) rotate(5deg);
          background: rgba(137, 199, 100, 0.12);
          border-color: rgba(137, 199, 100, 0.4);
          box-shadow: 0 10px 25px rgba(137, 199, 100, 0.2);
        }

        .center-img {
          width: 60px;
          height: auto;
          object-fit: contain;
        }

        .center-card h3 {
          font-weight: 800;
          font-size: 26px;
          margin-bottom: 18px;
          background: linear-gradient(135deg, #ffffff 40%, #89c764 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          letter-spacing: 0.5px;
        }

        .center-card p {
          color: #e2e8f0;
          font-size: 15px;
          line-height: 1.8;
          margin-bottom: 0;
          font-weight: 400;
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .center-card {
            margin: 50px 0;
            transform: none !important;
            padding: 45px 30px;
          }
          .center-card:hover {
            transform: translateY(-5px);
          }
          .main-heading {
            font-size: 38px;
            margin-bottom: 50px;
          }
        }

        @media (max-width: 768px) {
          .main-heading {
            font-size: 32px;
            margin-bottom: 40px;
          }
          .tax-modern {
            padding: 80px 0;
          }
          .service-card {
            padding: 30px 25px;
          }
        }
      `}} />
    </section>
  );
}

export default TaxServices;